// TODO 请求模块完善
import '@/utils/mockAccess'
import fetch from 'isomorphic-unfetch'
import { isInApp } from '@/utils'
import { signKey } from '@/constant'
import { Toast } from 'antd-mobile'
import Cookies from 'js-cookie'
import { formatUrl } from './config'
import md5 from 'md5'
import { getCookie } from '@/utils'
import { IncomingMessage } from 'http'

function addCookieTokenToParmasOrBody(data: any = {}, req?: IncomingMessage) {
  if (isInApp && !req) return data
  let cookieToken = ''
  if (req) {
    cookieToken = getCookie('duToken', req.headers.cookie)
  } else {
    cookieToken = Cookies.get('duToken')
  }
  if (cookieToken) {
    return {
      ...data,
      cookieToken,
    }
  }
  return data
}

function addPageId(data: any = {}, req?: IncomingMessage) {
  if (typeof window === 'undefined') return data
  const pathStr = location.pathname
  const pathList = pathStr.split('/')
  const pageId = pathList[pathList.length - 1]
  data.pageId = pageId
  return data
}

export interface SignParams {
  [key: string]: any
}

export interface ParseTokenOptions {
  params: SignParams
  scretKey: string
}

function isVoid(v) {
  if (v !== null && v !== undefined) {
    if (Object.prototype.toString.call(v) === '[object Object]') {
      return JSON.stringify(v)
    }
    return String(v)
  }
  return ''
}

/**
 * 加密方法
 *
 * @param {ParseTokenOptions} [options={ params: {}, scretKey: '' }]
 * @returns {string}
 */
function parseToken(options: ParseTokenOptions = { params: {}, scretKey: '' }): string {
  const { params, scretKey } = options
  let paramsToken = Object.keys(params)
    .sort()
    .reduce((prev, now) => prev + now + isVoid(params[now]), '')

  paramsToken += scretKey

  return md5(paramsToken)
}

// TODO 无副作用
function getSignAboutData(
  config: {
    method: string
    url: string
    data: any
    headers: any
  },
  scretKey: string,
  req?: IncomingMessage
): {
  url: string
  headers: any
  data: any
} {
  const { method, url, data, headers } = config
  const isPost = method === 'post'

  const tmpData = addPageId(addCookieTokenToParmasOrBody({ ...data }, req), req)

  const tmpHeaders = { ...headers } || {}
  let tmpUrl = url
  const sign = isPost
    ? parseToken({ params: tmpData, scretKey })
    : parseToken({ params: tmpData, scretKey })

  if (isPost) {
    tmpUrl += `?sign=${sign}`
  } else {
    tmpData.sign = sign
  }

  const xAuthToken = getCookie('x-auth-token')
  if (xAuthToken) {
    tmpHeaders['x-auth-token'] = getCookie('x-auth-token')
  }
  const duToken = getCookie('duToken')
  if (duToken) {
    // 与后端约定
    tmpHeaders.duToken = duToken
  }

  if (req) {
    tmpHeaders.cookie = req.headers.cookie
  }

  return {
    headers: tmpHeaders,
    url: tmpUrl,
    data: tmpData,
  }
}

function getDefaultHeaders(partialHeader: Partial<HeadersInit>): Partial<HeadersInit> {
  return {
    ...partialHeader,
    appVersion: '3.5.6',
    appId: 'h5',
    'Content-Type': 'application/json',
    SK: window.dw.getSk(), //增加接口反爬虫
  }
}

function errorHandler(res: Promise<Response>, config: any = {}): Promise<any> {
  return res
    .then((r) => r.json())
    .catch((e) => {
      console.error(e, 'pase json error')
    })
    .then((res) => {
      if (res.code === 700) {
        if (isInApp) {
          setTimeout(() => {
            Jockey.send('login')
          }, 1000)
        }
      }
      if (res.code !== 200 && res.status !== 200) {
        const showErrorToast = config.showErrorToast !== false

        if (showErrorToast && typeof window !== 'undefined') {
          Toast.info(res.msg, 2, null, false)
        }

        return Promise.reject(res)
      }
      return res
    })
}

/**
 * 1.
 * @param param0
 */
function post(params: {
  url: string
  headers?: Partial<Headers>
  data?: { [key: string]: any }
  req?: IncomingMessage
}) {
  const { data, headers, url } = getSignAboutData(
    {
      method: 'post',
      url: formatUrl(params.url),
      data: params.data,
      headers: params.headers,
    },
    signKey,
    params.req
  )
  return errorHandler(
    fetch(url, {
      headers: getDefaultHeaders(headers) as HeadersInit,
      body: JSON.stringify(data),
      method: 'post',
      credentials: 'include',
    })
  )
}

function get(params: {
  url: string
  // method: string
  headers?: Partial<Headers>
  data?: { [key: string]: any }
}) {
  const method = 'get'
  const { data, headers, url } = getSignAboutData(
    {
      method,
      url: formatUrl(params.url),
      data: params.data || {},
      headers: params.headers || {},
    },
    signKey
  )
  const urlObj = new URL(url)
  Object.keys(data).forEach((key) => urlObj.searchParams.append(key, encodeURIComponent(data[key])))
  return fetch(urlObj.toString(), {
    method,
    headers: getDefaultHeaders(headers) as HeadersInit,
  })
}

export default {
  fetch,
  get,
  post,
}
